import { ROUTE_MARKET, ROUTE_MARKET_HOME } from '@/constants/routes';
import { getPath } from '@/router/utils';
import useIndustryOptions from '@/pages/Market/hooks/useIndustryOptions';

import { find } from 'lodash';

export const useMarketIndustryUrlGetter = (key: string): string => {
  const parse = JSON.parse(key);
  const isValid = Array.isArray(parse) && parse.length > 1;
  const market = parse[0];
  const industryId = parse[1];
  const { options } = useIndustryOptions(
    false,
    market,
    isValid && market && industryId !== 0
  );

  const pathRequest = {
    type: market ? ROUTE_MARKET : ROUTE_MARKET_HOME,
    payload: {
      market,
    },
  };
  if (industryId === 0 || !isValid) {
    getPath(pathRequest);
  }
  const industryUrl = find(options, { id: industryId });
  return industryUrl ? industryUrl.href : getPath(pathRequest);
};
